<script>
export default {
  name: "ActionComponent",
  props: {
    deleteCartItemHandler: {
      type: Function,
      required: true
    },
    localStorageIndex: {
      type: Number,
      required: true
    }
  }
}
</script>

<template>
  <div class="td action">
    <button class="btn btn-custom" @click="deleteCartItemHandler(localStorageIndex)">
      <font-awesome-icon icon="trash" />
    </button>
  </div>
</template>

<style scoped>

</style>
